import SearInputM from '../../SearchModal';
import { useTranslation } from 'react-i18next';
import ParamsPicklist from '../../../Types/ParamsPicklist';
import { Box } from '@mui/material';
import SearchInput from '../../SearchInput';
import Utilisateur from '../../../Models/Utilisateur';
import { useAuthUser } from '../../../Services/Auth/sessionAuth';
import CheckboxF from '../../ChexBox';

//Initialisation des parametres de recherche
let searchNumCompte: ParamsPicklist = { CodeAgence: "", Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: "", Choix: 22 }
let searchTypeCompte: ParamsPicklist = { CodeAgence: "", Table: "TYPECPT", Colonne1: "CODTYP", Colonne2: "LIBELLE", Colagence: "", Choix: 22 }
let searchDevise: ParamsPicklist = { CodeAgence: "", Table: "DEVISE", Colonne1: "CODDEV", Colonne2: "LIBELL", Colagence: "", Choix: 22 }
let searchAgence: ParamsPicklist = { CodeAgence: "", Table: "AGENCE", Colonne1: "CODAGE", Colonne2: "LIBELLE", Colagence: "", Choix: 22 }
let searchClient: ParamsPicklist = { CodeAgence: '', Table: "CLIENT", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: '', Choix: 22 }
let searchPlanComptable: ParamsPicklist = { CodeAgence: "", Table: "plancp", Colonne1: "idplan", Colonne2: "LIBELL", Colagence: "", Choix: 22 }
let searchGestionnaire: ParamsPicklist = { CodeAgence: '', Table: "GESTIONNAIRE", Colonne1: "CODGES", Colonne2: "LIBELLE", Colagence: '001', Choix: 22 }

const Tab2 = (props: { etatG?: boolean, form?: any, Function1?: any, Function2?: any }) => {

  // const datas: DataType[] = [];
  //const {t,i18n}=useTranslation();
  const { t, i18n } = useTranslation();
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))

  //information du client
  let informationclient = {
    searchNumeroCompte: {
      Titre: "Recherche Numéro de Compte",
      label: "Numéro Compte",
      name: "NUMCPT", params: searchNumCompte
    },
    searchTypeCompte: {
      Titre: "Recherche Type de Compte",
      label: "Type Compte",
      name: "TYPCPT", params: searchTypeCompte
    },
    searchDevise: {
      Titre: "Recherche Dévise",
      label: "dévise",
      name: "CDDEVS", params: searchDevise
    },
    searchAgence: {
      Titre: "Recherche Agence",
      label: "Agence",
      name: "AGCCPT", params: searchAgence
    },
    SearchClient: {
      Titre: " Recherche Indice Client",
      label: "Indice Client",
      name: "NUMCLI", params: searchClient
    },
    Inputcle: {
      label: "Cle",
      name: "CLECLI"
    },
    searchPlanComptable: {
      Titre: "Recherche Plan Comptable",
      label: "Plan Comptable",
      name: "IDPLAN", params: searchPlanComptable
    },
    //--audit
    InputNom: {
      label: "Nom du Compte",
      name: "NOMCPT"
    },
    //--audit
    SearchGestionnaire: {
      Titre: "Recherche Gestionnaire",
      label: "Gestionnaire",
      name: "cdgest", params: searchGestionnaire
      //suspend
    }

  }

  return (

    <div className='tabItem' >
      <Box fontStyle="inherit" className='border-left border' width={"85%"} position={"absolute"}>
        
      </Box>

    </div>
  );
}

export default Tab2;